import { useState, useEffect } from 'react';

const DEFAULT_SCROLL_OFFSET = 100;

interface IScrollTo {
  side: 'left' | 'right';
  offset?: number;
}

const useHorizontalScroll = (initialScroll: number, ref: React.RefObject<HTMLElement>) => {
  const [scroll, setScroll] = useState(initialScroll);

  const scrollTo = ({ side, offset = DEFAULT_SCROLL_OFFSET }: IScrollTo) => {
    if (!ref.current) return;

    const maxScrollLeft = ref.current.scrollWidth - ref.current.clientWidth;

    if (side === 'right') {
      if (scroll + offset <= maxScrollLeft) {
        ref.current.scrollLeft += offset;
        setScroll(scroll + offset);
      } else {
        ref.current.scrollLeft = maxScrollLeft;
        setScroll(maxScrollLeft);
      }
    } else if (side === 'left') {
      if (scroll - offset >= 0) {
        ref.current.scrollLeft -= offset;
        setScroll(scroll - offset);
      } else {
        ref.current.scrollLeft = 0;
        setScroll(0);
      }
    }
  };

  useEffect(() => {
    if (!ref.current) return;

    const handleScroll = () => {
      setScroll(ref.current!.scrollLeft);
    };

    ref.current.addEventListener('scroll', handleScroll);

    return () => {
      ref.current?.removeEventListener('scroll', handleScroll);
    };
  }, [ref]);

  return { scroll, scrollTo };
};

export default useHorizontalScroll;
